module.exports = __webpack_public_path__ + "static/media/E-mail-icon.388653f0.png";